import Court from 'svg/Court';

interface Props {
  imageUrl?: string;
  clubName: string;
}

export default function CoverBanner({ imageUrl, clubName }: Props) {
  if (!imageUrl) {
    return (
      <div className="flex h-[6.5625rem] w-full items-center justify-center rounded-[1.25rem] bg-color-bg-lightmode-tertiary dark:bg-color-bg-darkmode-tertiary">
        <Court className="h-8 w-8 text-color-text-lightmode-icon dark:text-color-text-darkmode-icon" />
      </div>
    );
  }

  return (
    <img src={imageUrl} alt={clubName} className="h-[6.5625rem] w-full rounded-lg object-cover" />
  );
}
